import { ReactElement, type FC } from 'react';

import { useMedia } from '@pp/core/src/hooks/useMedia';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';

import { TableTabs } from '../../../../components/tableTabs/TableTabs';
import { RecentResultDetail } from '../../../recentResultDetail/RecentResultDetail';
import { MobileTableSheet } from '../../../tableSheet/mobileTableSheet/MobileTableSheet';
import { TableBetsConnected } from '../../../tableSheet/tableBets/TableBetsConnected';
import { InGameHistoryConnected } from '../../../tableSheet/tableHistory/InGameHistoryConnected';
import { TableStatsConnected } from '../../../tableSheet/tableStats/TableStatsConnected';
import { TableTopCashedMultipliers } from '../../../tableSheet/tableTop/cashedMultipliersAndWins/TableTopCashedMultipliers';
import { TableTopWins } from '../../../tableSheet/tableTop/cashedMultipliersAndWins/TableTopWins';
import { TableTopResults } from '../../../tableSheet/tableTop/results/TableTopResults';
import { TableTopConnected } from '../../../tableSheet/tableTop/TableTopConnected';

import styles from './TableSheetCellConnected.module.css';

const componentMapTop: Record<string, ReactElement> = {
  CRASH_CASHED_MULTIPLIERS: <TableTopCashedMultipliers />,
  STATISTICS_WINS: <TableTopWins />,
  STATISTICS_RESULTS_CAPS: <TableTopResults />,
};

const componentMap: Record<string, ReactElement> = {
  BETS_SHORT: <TableBetsConnected />,
  HISTORY: <InGameHistoryConnected />,
  STATISTICS_TOP: <TableTopConnected componentMapTop={componentMapTop} />,
  STATISTICS_STATS: <TableStatsConnected />,
};

export const TableSheetCellConnected: FC = () => {
  const isWide = useMedia('(min-width: 1024px) and (min-height: 500px)');

  return isWide ? (
    <div className={styles.tableSheetCellContainer}>
      <RecentResultDetail />
      <TableTabs
        classNameLabel={styles.tableSheetHeader}
        tabs={Object.keys(componentMap).map((tab) => ({
          label: <L10nText tk={tab} />,
          content: componentMap[tab],
          key: tab,
        }))}
      />
    </div>
  ) : (
    <MobileTableSheet />
  );
};
